import { FormField, SegmentedToggle } from '@wix/design-system';
import { HorizontalRatioSmall, VerticalRatioSmall } from '@wix/wix-ui-icons-common';
import React, { useContext } from 'react';

import { RicosContext } from './../../../../../ricos-context';
import type { LogBiFn } from './../../../../../_shared/bi-context-provider/bi-context-provider';
import { usePanelContainerElement } from './../../../../../ui-components';

import { LAYOUT_SETTINGS_SCROLL_DIRECTION_SEGMENTED_TOGGLE } from '../../../../data-hooks';

const SrollDirectionValue = {
  VERTICAL: 'vertical',
  HORIZONTAL: 'horizontal',
} as const;

type SrollDirectionType = (typeof SrollDirectionValue)[keyof typeof SrollDirectionValue];

type Props = {
  value: SrollDirectionType;
  onChange: (value: SrollDirectionType) => void;
  logBi: LogBiFn;
};

export const ScrollDirectionControl: React.FC<Props> = ({ value, onChange, logBi }) => {
  const { t } = useContext(RicosContext);
  const containerEl = usePanelContainerElement();

  return (
    <FormField
      label={t('GallerySettings_Radios_Scroll_Direction')}
      infoContent={t('GallerySettings_Radios_Scroll_Direction_Tooltip')}
      infoTooltipProps={{
        enterDelay: 300,
        appendTo: containerEl,
      }}
    >
      <SegmentedToggle
        selected={value}
        onClick={(_, value) => {
          logBi({ dataHook: LAYOUT_SETTINGS_SCROLL_DIRECTION_SEGMENTED_TOGGLE, value });
          onChange(value as SrollDirectionType);
        }}
        size="small"
        dataHook={LAYOUT_SETTINGS_SCROLL_DIRECTION_SEGMENTED_TOGGLE}
      >
        <SegmentedToggle.Button
          value={SrollDirectionValue.VERTICAL}
          prefixIcon={<VerticalRatioSmall />}
        >
          {t('GallerySettings_Radios_Vertical')}
        </SegmentedToggle.Button>
        <SegmentedToggle.Button
          value={SrollDirectionValue.HORIZONTAL}
          prefixIcon={<HorizontalRatioSmall />}
        >
          {t('GallerySettings_Radios_Horizontal')}
        </SegmentedToggle.Button>
      </SegmentedToggle>
    </FormField>
  );
};
